export default __webpack_public_path__ + "static/media/brewdog-background-img.a4e9a335.jpg";